import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractBaseComponent } from 'src/app/model/AbstractBaseComponent';

import { SharedService } from '../../../../shared/shared.service';
import { AFunzionalitaService } from '../a-funzionalita.service';

@Component({
  selector: 'app-genera-gruppi-studio',
  templateUrl: './genera-gruppi-studio.component.html',
  styleUrls: ['./genera-gruppi-studio.component.css'],
})
export class GeneraGruppiStudioComponent
  extends AbstractBaseComponent
  implements AfterViewInit, OnInit, OnDestroy {
  // COMBO BOX
  submitted = false;
  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private aFunzionalitaService: AFunzionalitaService
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  ngOnInit(): void {
    super.ngOnInit();
  }

  onSubmit() {
    this.submitted = true;
  }

  generaGruppiStudio() {
    this.spinner.show();
    this.aFunzionalitaService.generaGruppiStudio().subscribe(
      (result) => {
        if (result.esito) {
          this.spinner.hide();
          this.sharedService.openWarningModal(result.message);
        }
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore generaGruppiStudio');
      }
    );
  }
}
